import { render, staticRenderFns } from "./role.vue?vue&type=template&id=43fb182c&scoped=true"
import script from "./role.vue?vue&type=script&lang=ts"
export * from "./role.vue?vue&type=script&lang=ts"
import style0 from "./role.vue?vue&type=style&index=0&id=43fb182c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fb182c",
  null
  
)

export default component.exports